export default {
  'meta': {
    'langName': 'DUTCH',
    'lang': 'Nederlands'
  },
  'title': 'Terugroepactie Elektrische steps B\'\'twin SD500E of MD500E ',
  'description': 'Hallo,\n\nJe hebt een elektrische step van het merk B\'Twin gekocht (model SD 500E of MD500E) en we willen je graag bedanken voor je aankoop.\n\nJouw veiligheid is onze prioriteit, lees daarom de volgende informatie zorgvuldig door.\n\nOndanks strenge kwaliteitscontroles hebben we een veiligheidsdefect vastgesteld bij de elektrische steps B\'Twin SD500E en MD500E. Intensief gebruik kan leiden tot het ontstaan van een scheur op het knooppunt van het frame en de stuurpen. Dit defect kan een breuk op dit knooppunt veroorzaken, wat voor de gebruiker een risico op vallen met zich meebrengt.\n\nWe verzoeken je de volgende vragen te beantwoorden, zodat we je een veiligheidsoplossing voor je product kunnen bieden.\n\nOnze excuses voor het ongemak en bedankt voor je vertrouwen.\n\nDecathlon',
  'emailConfirmation': {
    'title': 'Kun je eerst jouw e-mailadres en land van verblijf bevestigen?'
  },
  'fields': {
    'country': 'Land',
    'address': 'E-mailadres',
    'email': 'E-mailadres',
    'phonePrefix': 'Landcode telefoon',
    'phone': 'Telefoonnummer',
    'validations': {
      'phoneOrEmail': 'Geef ten minste een e-mailadres of telefoonnummer op.',
      'email': 'Voer een geldig e-maildres in',
      'phone': 'Voer een geldig telefoonnummer in',
      'selectAddress': 'Selecteer een volledig adres uit de lijst (huisnummer, straatnaam en woonplaats).',
      'incompleteAddress': 'Het adres moet een huisnummer, straatnaam en plaatsnaam bevatten. Typ minimaal het huisnummer en de straatnaam in en kies vervolgens een suggestie.'
    },
    'firstName': 'Achternaam',
    'lastName': 'Voornaam',
    'deliveryAddress': 'Adres',
    'additionalAddress': 'Extra adresgegevens',
    'city': 'Woonplaats',
    'zip': 'Postcode',
    'readConfirmation': 'Ik bevestig dat mijn contactgegevens juist zijn en dat ik akkoord ga met de algemene voorwaarden.',
    'choose': 'Kies',
    'required': 'Dit veld is verplicht',
    'deliveryAddressHelp': 'Voer je huisnummer en naam in en kies vervolgens een volledig adres uit de lijst.',
    'streetOnlyHint': 'Voeg een huisnummer toe'
  },
  'ownerCheck': {
    'title': 'Ben je nog steeds de eigenaar van één of meerdere elektrische steps van het type B\'Twin SD500E en/of MD500E?'
  },
  'yes': 'Ja',
  'no': 'Nee',
  'ownerChanged': {
    'title': 'Heb je de contactgegevens van de huidige eigenaar(s)?',
    'confirmation': 'Beste klant, \n\nBedankt voor je deelname aan dit kwaliteitsinitiatief.\n\nOnze excuses voor het ongemak en wij danken je voor het vertrouwen.\n\nTeam Decathlon'
  },
  'recall': {
    'title': 'Geef het aantal B\'Twin SD500E en/of MD500E elektrische steps aan.',
    'descriptionSd500': 'Elektrische step SD500E',
    'descriptionEmd500e': 'Elektrische step MD500E',
    'modelNumberHelp': 'Je kunt het modelnummer (SD500E of MD500E) vinden onder je step, zoals hieronder weergegeven.',
    'quantity': 'Aantal',
    'confirmation': 'Bedankt voor je aanvraag! Deze is succesvol door ons ontvangen.\nJe hoort binnen uiterlijk 20 dagen van ons vanaf wanneer je jouw reparatie kunt inplannen.\n\nFijne dag nog!\n\nDecathlon'
  },
  'repair': {
    'title': 'Reparatie met jouw hulp',
    'description': 'Stop onmiddelijk met het gebruik van dit product.\n\nEr wordt een reparatieset en een handleiding naar je huisadres gestuurd, zodat je je step veilig kunt maken. Deze set wordt gratis naar je opgestuurd en de montage ervan is snel en eenvoudig.\n\nNa ontvangst van je gegevens nemen we binnen maximaal 20 dagen contact met je op om te bevestigen wanneer je reparatieset beschikbaar is. We doen er alles aan om deze termijn zo kort mogelijk te houden en je zo goed mogelijk van dienst te zijn. ',
    'videoLink': 'Link naar de video',
    'store': 'Link naar de handleiding',
    'kitLabel': 'Volledige reparatieset',
    'docLabel': 'Reparatieinstructies',
    'callToAction': 'Klik hier om je gratis reparatieset te ontvangen',
    'infoConfirmation': 'Controleer je gegevens',
    'validateConfirmation': 'Bevestig',
    'backConfirmation': 'Terug'
  },
  'repairRequest': {
    'title': 'Vul de volgende gegevens in om je reparatieset te ontvangen'
  },
  'form': {
    'submit': 'Volgende'
  },
  'status': 'Translation validated by COUNTRY'
} as const
